import { css } from "@emotion/css";
import classNames from "classnames";
import React from "react";

import { Text } from "../../../foundations/typography/Text";
export interface SubHeadingProps {
  children: React.ReactNode;
}

export function SubHeading({ children }: SubHeadingProps) {
  return (
    <Text
      as="div"
      className={classNames(
        css(styles, {
          background: "var(--background-accent-neutral-weak)",
          color: "var(--text-base)",
        })
      )}
      style="summary/section-title"
      color="text-base"
    >
      {children}
    </Text>
  );
}

const styles = css({
  paddingTop: "var(--space-1)",
  paddingRight: "var(--space-4)",
  paddingBottom: "var(--space-1)",
  paddingLeft: "var(--space-4)",
  textTransform: "uppercase",
});
